import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import { bookingApi } from "functions/apis";
import { useParams } from "react-router-dom";
import ListUser from "./ListUser";
import ListAvailableUserList from "./ListAvailableUserList";
import { GetAppNotificationTypeDescription } from "enums/AppsNotificationType";
import { Redirect } from "react-router-dom";
import NotificationDialog from "components/NotificationDialog/NotificationDialog";
import { GetAppNotificationTypeKey } from "enums/AppsNotificationType";

const useStyles = makeStyles(styles);

const EditAppsNotification = props => {
  const classes = useStyles();

  const [redirect, setRedirect] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [input, setInput] = useState({
    appsNotificationID: "",
    type: null,
    status: null,
    users: [],
    appsNotificationData: null
  });
  const [body, setBody] = useState({
    appsNotificationID: null,
    type: null,
    status: 0,
    users: []
  });
  const [selectedNotification, setSelectedNotification] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [reload, setReload] = React.useState({});
  const reloadHandler = () => {
    setReload({});
  };

  const { id } = useParams();

  const editSendAppsNotificationSignal = useRef(new AbortController());

  useEffect(() => {
    return () => editSendAppsNotificationSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      bookingApi
        .get("SendAppsNotificationTransactions/" + id, {
          signal: editSendAppsNotificationSignal.current.signal
        })
        .then(resp => {
          setInput({
            ...input,
            appsNotificationID: resp.appsNotification.id,
            status: resp.status,
            type: resp.type,
            appsNotificationData: resp.appsNotification
          });
          setBody({
            ...body,
            appsNotificationID: resp.appsNotification.id,
            status: resp.status,
            type: resp.type,
            users: []
          });
          setSelectedNotification(resp.appsNotification.name);
        });
    }
  }, [id]);

  const handleNotificationIDChanged = data => {
    setSelectedNotification(data.name);
    setInput({
      ...input,
      appsNotificationID: data.id
    });
    setBody({
      ...body,
      appsNotificationID: data.id
    });
    setIsOpen(false);
  };

  const handleNotificationTypeChanged = data => {
    setInput({
      ...input,
      type: GetAppNotificationTypeKey(data.target.value)
    });
    setBody({ ...body, type: GetAppNotificationTypeKey(data.target.value) });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .put("SendAppsNotificationTransactions/" + id, body, {
        signal: editSendAppsNotificationSignal.current.signal
      })
      .then(resp => {
        console.log(resp);
        setRedirect(true);
      })
      .finally(() => {
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/SendAppsNotification/InDraft"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Edit Send Apps Notification
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <TextField
                className={classes.option}
                value={selectedNotification}
                label={"Notification"}
                variant="standard"
                onClick={() => {
                  setIsOpen(true);
                }}
                fullWidth={true}
              />
              <NotificationDialog
                onSelect={handleNotificationIDChanged}
                openModal={isOpen}
                setOpenModal={val => {
                  setIsOpen(val);
                }}
              />
              <FormControl
                style={{ cursor: "pointer" }}
                fullWidth
                className={classes.selectFormControl}
              >
                <InputLabel
                  htmlFor="selCategory"
                  className={classes.selectLabel}
                >
                  Notification Type
                </InputLabel>
                <Select
                  MenuProps={{
                    classes: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  value={
                    input.type != null
                      ? GetAppNotificationTypeDescription(input.type)
                      : ""
                  }
                  onChange={handleNotificationTypeChanged}
                >
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected
                    }}
                    key={"All"}
                    value={`All`}
                  >
                    <b>{`All`}</b>
                  </MenuItem>
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected
                    }}
                    key={"SpecificUser"}
                    value={"SpecificUser"}
                  >
                    <b>{`Specific Users`}</b>
                  </MenuItem>
                </Select>
              </FormControl>

              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                Submit
              </Button>
            </form>
          </CardBody>
        </Card>
        {input.type != 0 && input.type && (
          <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
              <ListUser id={id} reload={reload} reloadHandler={reloadHandler} />
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <ListAvailableUserList
                id={id}
                reload={reload}
                reloadHandler={reloadHandler}
              />
            </GridItem>
          </GridContainer>
        )}
      </GridItem>
    </GridContainer>
  );
};

export default EditAppsNotification;

EditAppsNotification.propTypes = {
  history: PropTypes.object
};
